export default __webpack_public_path__ + "static/media/AMS - Download to OI2.b708e71c.svg";